import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExportFormatsApiService } from 'src/app/services/api/export-formats.service';
import { LocaleService } from 'src/app/services/locale.service';
import { AnalyticsService } from 'src/app/_core/analytics/analytics.service';
import { UserActionName } from 'src/app/_core/analytics/events/user-event';

@Component({
  selector: 'export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss'],
})
export class ExportButtonComponent implements OnInit, OnDestroy {
  textDirection: string;
  private unsubscribe: Subject<void> = new Subject();
  private readonly analyticsService = inject(AnalyticsService);

  readonly showConfirmationDialog = signal(false);

  constructor(
    private exportFormatsApiService: ExportFormatsApiService,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
  }

  emitFormat(formatParam: string) {
    const actionName: UserActionName = formatParam === 'pdf' ? 'history_exported_to_pdf' : 'history_exported_to_excel';

    this.exportFormatsApiService.getExportFormat(formatParam).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result) => {
        if (result.status === 'dialog-required') {
          this.showConfirmationDialog.set(true);
        }

        this.analyticsService.sendUserActionEvent(actionName, true);
      },
      error: () => this.analyticsService.sendUserActionEvent(actionName, false),
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
